const setGTMVariables = (preference, adTrackingPreference) => {
  if (typeof window !== 'undefined') {
    if (!window.dataLayer) window.dataLayer = [];
    const gtmData = [{
      consent: preference.consent
    }, {
      adConsent: adTrackingPreference.value.toString()
    }];
    window.dataLayer.push(...gtmData);
  }
};
export { setGTMVariables as default };
//# sourceMappingURL=setGTMVariables.js.map
